// import vue
import Vue from 'vue'

// import notifications
import Notifications from 'vue-notification'

Vue.use(Notifications)
